import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { PRODUCT_MAP, fmt } from "@/lib/load/products";
import { ApiSymbol } from "@/components/load/ApiSymbol";
import { METRIC, toShown, fromShown } from "@/lib/units";
import { ProductSelect } from "@/components/load/ProductSelect";

export const OrderLine = ({ line, onChange, onFull, onProduct, onRemove, t }) => {
  const p = PRODUCT_MAP[line.product];
  const id = line.key, v = line.gallons;
  const shown = Math.round(toShown(v, "gal"));
  const [draft, setDraft] = useState(null);
  useEffect(() => { setDraft(null); }, [v]);
  const steps = METRIC ? [500, 2000] : [100, 1000];
  return (
    <div className={`load-line ${v > 0 ? "has-val" : ""}`} style={{ borderLeftColor: p.text }} data-testid={`product-card-${id}`}>
      <div className="load-line-head">
        <ApiSymbol p={p} size={22} />
        {onProduct ? <ProductSelect value={line.product} onChange={onProduct} testId={`product-select-${id}`} />
          : <span className="load-line-name">{line.label || p.name}{line.label && <small>{p.name}</small>}</span>}
        {onRemove && <button type="button" className="header-btn" onClick={onRemove} aria-label={t("Remove")} data-testid={`remove-product-${id}`}><X size={16} /></button>}
      </div>
      <div className="load-line-sub"><span style={{ color: p.text }}>API {p.api}</span><span>{p.un}</span></div>
      <div className="load-line-input">
        <input className="num-input" inputMode="numeric" value={draft ?? (v ? fmt(shown) : "")} onBlur={() => setDraft(null)} placeholder="0" data-testid={`order-input-${id}`}
          onChange={(e) => { const d = e.target.value.replace(/\D/g, ""); onChange(Math.min(99999, fromShown(parseInt(d || "0", 10), "gal"))); setDraft(d); }} />
        <span>{METRIC ? "L" : "gal"}</span>
      </div>
      <div className="load-steps">
        <button type="button" className="ghost-btn" onClick={() => onChange(v + fromShown(steps[0], "gal"))} data-testid={`order-plus100-${id}`}>+{steps[0]}</button>
        <button type="button" className="ghost-btn" onClick={() => onChange(v + fromShown(steps[1], "gal"))} data-testid={`order-plus1000-${id}`}>+{steps[1]}</button>
        <button type="button" className="ghost-btn load-full" onClick={onFull} data-testid={`order-full-${id}`}>{t("FULL")}</button>
        <button type="button" className="ghost-btn" onClick={() => onChange(0)} data-testid={`order-zero-${id}`}>0</button>
      </div>
    </div>
  );
};
